import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import Loader from "react-spinner-loader";
import { Deleteicon, Editicon } from "../../../../Components/IconComponents";
import Confirmpopup from "../../Common/ConfirmPopup/Confirmpopup";
import Table from "../../../../Components/UiComponents/Table/Table";
import { getExportedColumnsData } from "../../../../Components/UiComponents/utils";
import { setTableData } from "../../../../CentralStore/ExportLMSTable/dataSlice";
import { getData, putDataWithBody } from "../../../../Services/Services";
import { deleteUserById, getThemeURL, getUserLog, getUsersFromApp } from "../../../../Services/EndPoints";
import { contactTableData, userActivityTableDataForExport, userTableDatacolumnsForExport } from "../../../../JsonData/ContactConfig";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { RoleContext } from "../../../..";
import { Filter as FilterIcon } from "lucide-react";

const TODAY_STR = new Date().toISOString().split("T")[0];

const filterLabelStyle = {
  fontSize: "9.5px",
  fontWeight: 800,
  letterSpacing: ".3px",
  textTransform: "uppercase",
  color: "#98A2B3",
};

const filterControlStyle = {
  padding: "6px 10px",
  borderRadius: "8px",
  border: "1px solid #E4E7EC",
  fontSize: "12px",
  background: "#fff",
  color: "#1D2939",
  height: "34px",
  boxSizing: "border-box",
};

// Row dates come back as parseable date strings; normalise to local YYYY-MM-DD for range checks.
const toDateKey = (value) => {
  const d = new Date(value);
  if (isNaN(d.getTime())) return "";
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};
// import {
//   Editicon,
//   Deleteicon,
//   Viewicon,
// } from "../../../../Components/IconComponents";
// import Table from "../../../../Components/UiComponents/Table/Table";
// //import { Modal, Button } from "react-bootstrap";
// import {
//   contactTableData,
//   userTableDatacolumnsForExport,
// } from "../../../../JsonData/ContactConfig";
// import {
//   getUsersFromApp,
//   deleteContactURL,
//   deleteUserById,
// } from "../../../../Services/EndPoints";
// import { toast, ToastContainer } from "react-toastify";
// import { useDispatch } from "react-redux";
// import { getData, putDataWithBody } from "../../../../Services/Services";
// import { getExportedColumnsData } from "../../../../Components/UiComponents/utils";
// import { setTableData } from "../../../../CentralStore/ExportLMSTable/dataSlice";
// import Confirmpopup from "../../Common/ConfirmPopup/Confirmpopup";
// import StatusHandler from "../../Common/StatusHandler/StatusHandler";
// import { useTranslation } from "react-i18next";
// import { RoleContext } from "../../../..";

const UserActivityTable = forwardRef((props, ref) => {
  const { roleName } = useContext(RoleContext);
  const dispatch = useDispatch();
  const qs = require("qs");
  const [userData, setUserData] = useState([]);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const { t, i18n } = useTranslation();
  const [searchData, setSearchData] = useState([]);
  const [detailFilter, setDetailFilter] = useState("All");
  const [activityFilter, setActivityFilter] = useState("All");
  // Date range only takes effect once "Apply" is clicked.
  const [pendingDateFrom, setPendingDateFrom] = useState("");
  const [pendingDateTo, setPendingDateTo] = useState("");
  const [appliedDateFrom, setAppliedDateFrom] = useState("");
  const [appliedDateTo, setAppliedDateTo] = useState("");


//   const formatSearchData = (data) => {
//     return data.map(role => {
//         // Create a string of comma-separated permission names
//         const formattedUserRole = role.user_role_map.map(obj => {
//             return obj.roleEntity.name;
//         }).join(", "); // Join the permission names with a comma and space

//         // Return the role with formatted permissions as a string
//         return {
//             ...role,
//             user_role_map: formattedUserRole, // Replace array with the formatted string
//         };
//     });
// };

//   console.log(searchData,"searchuserdata");
//   useEffect(() => {
//     const formattedData = formatSearchData(searchData);
//     console.log(formattedData,"formatedUserroles");
//     sendDataToCentralStore(formattedData);
//   }, [searchData]);

  useEffect(() => {
    getUserList();
  }, []);
  
//   const addNewHandler = () => {
//     navigate("/users/create-user");
//   };

  const formatTime12Hour = (timeStr) => {
    if (!timeStr) return "NA";
    const parts = timeStr.split(":");
    let hours = parseInt(parts[0], 10);
    const minutes = parts[1] || "00";
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    const hoursStr = hours.toString().padStart(2, "0");
    return `${hoursStr}:${minutes} ${ampm}`;
  };

  const getShortenedText = (strLength, fulltext) => {
    let abbreviatedText = "";
    if (fulltext.length > strLength) {
      abbreviatedText = fulltext.substring(0, 15) + "...";
    } else {
      abbreviatedText = fulltext;
    }
    return <span title={fulltext}>{abbreviatedText}</span>;
  };
  const getUserList = async () => {
    setLoader(true);
    const userProfile = await getData(getThemeURL);
    const state_id = userProfile[0]?.state_id;
    var userList = await getData(`${getUserLog}/${state_id}`);
    sendDataToCentralStore(userList);
    setLoader(false);
    console.log('ssss',userList);
    setUserData(userList);
  };

  const detailOptions = React.useMemo(
    () => Array.from(new Set(["Web", "Mobile", ...(userData || []).map((r) => r.detail).filter(Boolean)])).sort(),
    [userData]
  );
  const activityOptions = React.useMemo(
    () => Array.from(new Set((userData || []).map((r) => r.activity).filter(Boolean))).sort(),
    [userData]
  );

  const isDateRangeInvalid =
    !!pendingDateFrom && !!pendingDateTo && new Date(pendingDateFrom) > new Date(pendingDateTo);

  const handleApplyDateFilter = () => {
    if (isDateRangeInvalid) return;
    setAppliedDateFrom(pendingDateFrom);
    setAppliedDateTo(pendingDateTo);
  };

  const filteredUserData = React.useMemo(() => {
    return (userData || []).filter((row) => {
      if (detailFilter !== "All" && row.detail !== detailFilter) return false;
      if (activityFilter !== "All" && row.activity !== activityFilter) return false;
      if (appliedDateFrom || appliedDateTo) {
        const key = toDateKey(row.date);
        if (!key) return false;
        if (appliedDateFrom && key < appliedDateFrom) return false;
        if (appliedDateTo && key > appliedDateTo) return false;
      }
      return true;
    });
  }, [userData, detailFilter, activityFilter, appliedDateFrom, appliedDateTo]);

  const hasActiveFilters =
    detailFilter !== "All" || activityFilter !== "All" || appliedDateFrom !== "" || appliedDateTo !== "";

  const clearAllFilters = () => {
    setDetailFilter("All");
    setActivityFilter("All");
    setPendingDateFrom("");
    setPendingDateTo("");
    setAppliedDateFrom("");
    setAppliedDateTo("");
  };
  //   useEffect(() => {
  //     if (props.locationInstance && props.locationInstance.msg != "") {
  //       toast.success("Agency has been created successfully.", {
  //         position: toast.POSITION.TOP_CENTER,
  //         autoClose: 2000, // Close after 2 seconds
  //       });
  //     }
  //     getAgecnyList();
  //   }, []);

//   const sendDataToCentralStore = (data) => {
//     if (data.length > 0) {
//       // Step 1: Sort data by date and time in descending order
//       const sortedData = [...data].sort((a, b) => {
//         // Combine date and time for accurate sorting
//         const datetimeA = new Date(`${a.date}T${a.time}`);
//         const datetimeB = new Date(`${b.date}T${b.time}`);
        
//         return datetimeB - datetimeA; // Sort descending
//       });
  
//       // Step 2: Export the sorted data
//       const columns = userActivityTableDataForExport; // Columns config
//       dispatch(
//         setTableData({
//           columns,
//           tableData: getExportedColumnsData(columns, sortedData),
//         })
//       );
//     }
//   };

const sendDataToCentralStore = (data) => {
    if (data.length > 0) {
      // Step 1: Format the date for each record
      const formattedData = data.map((item) => {
        // Format the date as dd-mm-yyyy
        const date = new Date(item.date);
        const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;
        return { ...item, date: formattedDate }; // Update the date field
      });
  
      // Step 2: Export the formatted data
      const columns = userActivityTableDataForExport; // Columns config
  
      dispatch(
        setTableData({
          columns,
          tableData: getExportedColumnsData(columns, formattedData), // Send the formatted data
        })
      );
    }
  };
  
  
  //   const navToCreatAgency = (parentAgencyId) => {
  //     navigate("/agencylist/createagency", {
  //       state: { parentAgencyId: parentAgencyId },
  //     });
  //   };
  //   const getAgecnyList = async () => {
  //     var agencyList = await getData(agencyListURL);
  //     setAgencyData(agencyList);
  //     sendDataToCentralStore(agencyList);
  //   };

  //   Name:"",
  //   Phone1:"",
  //   Phone2:"",
  //   Email:"",
  //   Address:"",
  //   ContactType:"",
  //   Agency:"",

 // Define sorting functions outside the component
// const dateTimeSort = (rowA, rowB) => {
//     const datetimeA = new Date(`${rowA.values.date}T${rowA.values.time}`);
//     const datetimeB = new Date(`${rowB.values.date}T${rowB.values.time}`);
//     return datetimeB - datetimeA; // descending order
//   };
  
  const columns = React.useMemo(
    () => [
        {
            Header: t("useractivitytableheaders.name"),
            accessor: "name",
            disableSortBy: true,
          },
          {
            Header: t("useractivitytableheaders.username"),
            accessor: "user_name",
            disableSortBy: true,
          },
          {
            Header: t("useractivitytableheaders.agency"),
            accessor: "agency",
            disableSortBy: true,
          },
        //   {
        //     Header: t("useractivitytableheaders.user_region"),
        //     accessor: "user_region",
        //     disableSortBy: true,
        //   },
          {
            Header: t("useractivitytableheaders.detail"),
            accessor: "detail",
            disableSortBy: true,
          },
          {
            Header: t("useractivitytableheaders.activity"),
            accessor: "activity",
            disableSortBy: true,
          },
         
          {
            Header: t("useractivitytableheaders.date"),
            accessor: "date",
            disableSortBy: true, // Disable sorting on the date column
            Cell: (props) => {
              // Format the date as dd-mm-yyyy
              const date = new Date(props.value);
              const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;
              
              return <span>{formattedDate}</span>;
            },
          },
          {
            Header: t("useractivitytableheaders.time"),
            accessor: "time",
            disableSortBy: true, // Disable sorting on the time column
            Cell: (props) => {
              return <span>{formatTime12Hour(props.value)}</span>; // Custom Cell rendering for time
            },
          },
    //   {
    //     Header: t("useractivitytableheaders.phone"),
    //     accessor: "phone_number",
    //     disableSortBy: true,
    //   },
    //   {
    //     Header: t("useractivitytableheaders.role"),
    //     accessor: "role",
    //     disableSortBy: true,
    //   },
      
      
      
    //   {
    //     Header: t("useractivitytableheaders.job_title"),
    //     accessor: "job_title",
    //     disableSortBy: true,
    //   },
    //   {
    //     Header: t("useractivitytableheaders.time"),
    //     accessor: "time",
    //     disableSortBy: true,
    //     sortType: dateTimeSort, // Same here for time column
    //     initialSortDesc: true,
    //     Cell: (props) => {
    //       return <span>{props.value}</span>; // Custom Cell rendering for time
    //     },
    //   },
    //   {
    //     Header: t("useractivitytableheaders.ipaddress"),
    //     accessor: "ip_address",
    //     disableSortBy: true,
    //   },
    ],
    [t]
  );

  const exportData = React.useMemo(
    () =>
      (filteredUserData || []).map((item) => {
        const date = new Date(item.date);
        const formattedDate = isNaN(date)
          ? item.date
          : `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()}`;
        return { ...item, date: formattedDate };
      }),
    [filteredUserData]
  );

  return (
    <div className="create-user useractivity-mgmt-table">
      <style>{`
        #light .useractivity-mgmt-table .iccc--table th {
          background: linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%) !important;
          color: #ffffff !important;
        }
        #light .useractivity-mgmt-table .iccc--table tbody tr td,
        #light .useractivity-mgmt-table .iccc--table tbody tr th {
          border: none !important;
        }
        #light .useractivity-mgmt-table .iccc--table tbody tr td {
          background-color: #fff !important;
        }
        #light .useractivity-mgmt-table .iccc--table tbody tr:nth-child(even) td {
          background-color: #F9FAFB !important;
        }
        .useractivity-mgmt-table .search-form {
          position: relative;
          display: inline-flex;
          align-items: center;
        }
        .useractivity-mgmt-table .search-form input[type="text"] {
          height: 36px !important;
          line-height: 34px !important;
          padding: 0 40px 0 12px !important;
          border: 1px solid #E4E7EC !important;
          border-radius: 8px !important;
          font-size: 12px !important;
          box-sizing: border-box !important;
        }
        .useractivity-mgmt-table .search-form button {
          position: absolute !important;
          top: 0 !important;
          bottom: 0 !important;
          right: 0 !important;
          height: 36px !important;
          width: 36px !important;
          margin: 0 !important;
          padding: 0 !important;
          background-color: transparent !important;
          border: none !important;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .useractivity-mgmt-table .search-icon {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .useractivity-mgmt-table .search-icon svg {
          display: block;
          color: #2E6DA4;
        }
      `}</style>
      <Loader
        show={loader}
        type="body"
        stack="vertical"
        message="Loading Data"
      />
      <div style={{ background: "#fff", border: "1px solid #EEF1F5", borderRadius: "10px", boxShadow: "0 1px 2px rgba(16,24,40,0.04)", padding: "10px 14px", margin: "12px 12px 12px 12px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "10px" }}>
          <span style={{ width: "20px", height: "20px", borderRadius: "6px", background: "#EBF4FA", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <FilterIcon size={11} color="#2E6DA4" />
          </span>
          <span style={{ fontSize: "12px", fontWeight: 800, color: "#2E6DA4" }}>Filters</span>
        </div>
        <style>{`
          .useractivity-filter-bar input[type="date"] {
            position: relative;
            padding-right: 30px;
            display: inline-flex;
            align-items: center;
          }
          .useractivity-filter-bar input[type="date"]::-webkit-datetime-edit {
            display: inline-flex;
            align-items: center;
            padding: 0;
            line-height: normal;
          }
          .useractivity-filter-bar input[type="date"]::-webkit-datetime-edit-fields-wrapper {
            display: inline-flex;
            align-items: center;
          }
          .useractivity-filter-bar input[type="date"]::-webkit-calendar-picker-indicator {
            position: absolute;
            right: 8px;
            top: 50%;
            transform: translateY(-50%);
            margin: 0;
            padding: 0;
            cursor: pointer;
            opacity: 0.55;
          }
          .useractivity-filter-bar input[type="date"]::-webkit-inner-spin-button,
          .useractivity-filter-bar input[type="date"]::-webkit-clear-button {
            display: none;
          }
        `}</style>
        <div className="useractivity-filter-bar" style={{ display: "flex", gap: "14px", flexWrap: "wrap", alignItems: "flex-end" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: "0 1 180px" }}>
            <label style={filterLabelStyle}>Detail</label>
            <select value={detailFilter} onChange={(e) => setDetailFilter(e.target.value)} style={{ ...filterControlStyle, width: "100%" }}>
              <option value="All">Detail</option>
              {detailOptions.map((d) => (<option key={d} value={d}>{d}</option>))}
            </select>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: "0 1 180px" }}>
            <label style={filterLabelStyle}>Activity</label>
            <select value={activityFilter} onChange={(e) => setActivityFilter(e.target.value)} style={{ ...filterControlStyle, width: "100%" }}>
              <option value="All">Activity</option>
              {activityOptions.map((a) => (<option key={a} value={a}>{a}</option>))}
            </select>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: "0 1 160px" }}>
            <label style={filterLabelStyle}>From Date</label>
            <input
              type="date"
              value={pendingDateFrom}
              max={pendingDateTo && pendingDateTo < TODAY_STR ? pendingDateTo : TODAY_STR}
              onChange={(e) => setPendingDateFrom(e.target.value)}
              style={{ ...filterControlStyle, width: "100%" }}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: "0 1 160px" }}>
            <label style={filterLabelStyle}>To Date</label>
            <input
              type="date"
              value={pendingDateTo}
              min={pendingDateFrom || undefined}
              max={TODAY_STR}
              onChange={(e) => setPendingDateTo(e.target.value)}
              style={{ ...filterControlStyle, width: "100%" }}
            />
          </div>
          <button
            type="button"
            onClick={handleApplyDateFilter}
            disabled={!pendingDateFrom || !pendingDateTo || isDateRangeInvalid}
            title="Applies the From Date / To Date range"
            style={{
              height: "34px", padding: "0 16px", borderRadius: "6px", fontSize: "12px", fontWeight: 600,
              border: "1px solid #2E6DA4",
              background: (!pendingDateFrom || !pendingDateTo || isDateRangeInvalid) ? "#a9c3d8" : "#2E6DA4",
              color: "#fff",
              cursor: (!pendingDateFrom || !pendingDateTo || isDateRangeInvalid) ? "not-allowed" : "pointer",
            }}
          >
            Apply
          </button>
          {hasActiveFilters && (
            <button
              type="button"
              onClick={clearAllFilters}
              style={{ height: "34px", padding: "0 12px", borderRadius: "8px", border: "1px solid #E4E7EC", background: "#F9FAFB", color: "#475467", fontSize: "12px", fontWeight: 600, cursor: "pointer" }}
            >
              Clear Filters
            </button>
          )}
        </div>
        {isDateRangeInvalid && (
          <div style={{ marginTop: "8px", fontSize: "11px", color: "#DC2626", fontWeight: 600 }}>
            "From Date" must be on or before "To Date".
          </div>
        )}
      </div>
      <div className="datatable__container">
        {contactTableData && (
          <Table
            data={filteredUserData}
            columns={columns}
            numberOfRows={10}
            setSearchData={setSearchData}
            searchPlaceholder="Search by User Name, Agency, Activity, Detail"
            searchInputStyle={{ width: "19em" }}
            // addButtonLabel={t("createuseraddbuttonlabel")}
            // addNewHandler={addNewHandler}
            showExport={false}
            showExcelExport={true}
            exportData={exportData}
            exportColumns={userActivityTableDataForExport}
            exportFileName="UserActivity"
            showFilter={false}
            showReset={false}
            onExpand={false}
            rowCount={filteredUserData.length}
            headerTableHeadStyle={{ background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)", color: "#FFFFFF" }}
            tableStyle={{
              border: "1px solid #EEF1F5",
              borderRadius: "10px",
              boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
            }}
          />
        )}
      </div>
    </div>
  );
});

export default UserActivityTable;
